module.exports = __webpack_public_path__ + "img/nb_0.6f460105.png";